import React from 'react';
import { Phone, User, DollarSign, MapPin, X, Trash2, StickyNote, Mail } from 'lucide-react';

export const AddDealModal = ({ newDeal, setNewDeal, STAGES, handleAddDeal, onClose }) => (
  <div style={{ position: 'fixed', inset: 0, zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.8)' }}
    onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
    <div style={{ width: '95%', maxWidth: '450px', background: '#1a1a1a', border: '3px solid #FFD700', borderRadius: '12px', boxShadow: '8px 8px 0px 0px #FFD700', overflow: 'hidden', maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
      <div style={{ padding: '1.25rem', borderBottom: '2px solid #333', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
        <h3 style={{ fontFamily: "'Bangers', cursive", fontSize: '1.5rem', color: '#FFD700', letterSpacing: '0.03em' }}>New Mission</h3>
        <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer' }}><X size={20} /></button>
      </div>
      <form onSubmit={handleAddDeal} style={{ padding: '1.25rem', display: 'flex', flexDirection: 'column', gap: '0.75rem', overflowY: 'auto', flex: 1 }}>
        {[
          { key: 'restaurant_name', label: 'Restaurant Name', icon: <User size={16} />, required: true },
          { key: 'phone', label: 'Phone', icon: <Phone size={16} /> },
          { key: 'contact', label: 'Contact Person', icon: <User size={16} /> },
          { key: 'email', label: 'Email', icon: <Mail size={16} /> },
          { key: 'street_address', label: 'Street Address', icon: <MapPin size={16} /> },
          { key: 'state', label: 'State', icon: <MapPin size={16} /> },
          { key: 'zipcode', label: 'Zip Code', icon: <MapPin size={16} /> },
          { key: 'deal_value', label: 'Deal Value ($)', icon: <DollarSign size={16} />, type: 'number', required: true },
        ].map(f => (
          <div key={f.key}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', fontWeight: 700, fontSize: '0.85rem', color: '#aaa', marginBottom: '0.3rem', textTransform: 'uppercase' }}>{f.icon} {f.label}</label>
            <input
              data-testid={`new-deal-${f.key}`}
              type={f.type || 'text'}
              value={newDeal[f.key]}
              onChange={(e) => setNewDeal({ ...newDeal, [f.key]: e.target.value })}
              required={f.required}
              style={{ width: '100%', padding: '0.625rem', background: '#111', border: '2px solid #333', borderRadius: '6px', color: '#fff', fontSize: '0.95rem', outline: 'none', boxSizing: 'border-box' }}
              onFocus={(e) => e.target.style.borderColor = '#FFD700'}
              onBlur={(e) => e.target.style.borderColor = '#333'}
            />
          </div>
        ))}
        <div>
          <label style={{ fontWeight: 700, fontSize: '0.85rem', color: '#aaa', marginBottom: '0.3rem', display: 'block', textTransform: 'uppercase' }}>Stage</label>
          <select
            data-testid="new-deal-stage"
            value={newDeal.stage}
            onChange={(e) => setNewDeal({ ...newDeal, stage: e.target.value })}
            style={{ width: '100%', padding: '0.625rem', background: '#111', border: '2px solid #333', borderRadius: '6px', color: '#fff', fontSize: '0.95rem', outline: 'none' }}
          >
            {STAGES.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
        <button data-testid="submit-deal-btn" type="submit" style={{
          marginTop: '0.5rem', padding: '0.75rem', background: '#FFD700', color: '#000',
          border: '3px solid #000', borderRadius: '8px', fontWeight: 800, fontSize: '1rem',
          textTransform: 'uppercase', cursor: 'pointer', boxShadow: '3px 3px 0px 0px #000',
        }}>
          Deploy Mission
        </button>
      </form>
    </div>
  </div>
);

export const EditDealModal = ({ editDeal, setEditDeal, STAGES, handleUpdateDeal, handleDeleteDeal }) => (
  <div style={{ position: 'fixed', inset: 0, zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.8)' }}
    onClick={(e) => { if (e.target === e.currentTarget) setEditDeal(null); }}>
    <div style={{ width: '95%', maxWidth: '450px', background: '#1a1a1a', border: '3px solid #6A0DAD', borderRadius: '12px', boxShadow: '8px 8px 0px 0px #6A0DAD', overflow: 'hidden', maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
      <div style={{ padding: '1.25rem', borderBottom: '2px solid #333', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
        <h3 style={{ fontFamily: "'Bangers', cursive", fontSize: '1.5rem', color: '#6A0DAD', letterSpacing: '0.03em' }}>Edit Mission</h3>
        <button onClick={() => setEditDeal(null)} style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer' }}><X size={20} /></button>
      </div>
      <div style={{ padding: '1.25rem', display: 'flex', flexDirection: 'column', gap: '0.75rem', overflowY: 'auto', flex: 1 }}>
        {[
          { key: 'restaurant_name', label: 'Restaurant Name' },
          { key: 'phone', label: 'Phone' },
          { key: 'contact', label: 'Contact Person' },
          { key: 'email', label: 'Email' },
          { key: 'street_address', label: 'Street Address' },
          { key: 'state', label: 'State' },
          { key: 'zipcode', label: 'Zip Code' },
          { key: 'deal_value', label: 'Deal Value ($)', type: 'number' },
        ].map(f => (
          <div key={f.key}>
            <label style={{ fontWeight: 700, fontSize: '0.85rem', color: '#aaa', marginBottom: '0.3rem', display: 'block', textTransform: 'uppercase' }}>{f.label}</label>
            <input
              type={f.type || 'text'}
              value={editDeal[f.key] || ''}
              onChange={(e) => setEditDeal({ ...editDeal, [f.key]: e.target.value })}
              style={{ width: '100%', padding: '0.625rem', background: '#111', border: '2px solid #333', borderRadius: '6px', color: '#fff', fontSize: '0.95rem', outline: 'none', boxSizing: 'border-box' }}
              onFocus={(e) => e.target.style.borderColor = '#6A0DAD'}
              onBlur={(e) => e.target.style.borderColor = '#333'}
            />
          </div>
        ))}
        <div>
          <label style={{ fontWeight: 700, fontSize: '0.85rem', color: '#aaa', marginBottom: '0.3rem', display: 'block', textTransform: 'uppercase' }}>Stage</label>
          <select
            value={editDeal.stage}
            onChange={(e) => setEditDeal({ ...editDeal, stage: e.target.value })}
            style={{ width: '100%', padding: '0.625rem', background: '#111', border: '2px solid #333', borderRadius: '6px', color: '#fff', fontSize: '0.95rem', outline: 'none' }}
          >
            {STAGES.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
        <div>
          <label style={{ fontWeight: 700, fontSize: '0.85rem', color: '#aaa', marginBottom: '0.3rem', display: 'block', textTransform: 'uppercase' }}>
            <StickyNote size={12} style={{ display: 'inline', marginRight: '4px' }} />Notes
          </label>
          <textarea
            data-testid="deal-notes-input"
            value={editDeal.notes || ''}
            onChange={(e) => setEditDeal({ ...editDeal, notes: e.target.value })}
            placeholder="Call notes, follow-up details..."
            rows={3}
            style={{
              width: '100%', padding: '0.625rem', background: '#111', border: '2px solid #333',
              borderRadius: '6px', color: '#fff', fontSize: '0.9rem', outline: 'none',
              boxSizing: 'border-box', resize: 'vertical', fontFamily: 'inherit',
            }}
            onFocus={(e) => e.target.style.borderColor = '#6A0DAD'}
            onBlur={(e) => e.target.style.borderColor = '#333'}
          />
        </div>
        <div style={{ display: 'flex', gap: '0.75rem', marginTop: '0.5rem' }}>
          <button onClick={handleUpdateDeal} style={{
            flex: 1, padding: '0.75rem', background: '#6A0DAD', color: '#fff',
            border: '3px solid #000', borderRadius: '8px', fontWeight: 800, fontSize: '0.9rem',
            textTransform: 'uppercase', cursor: 'pointer', boxShadow: '3px 3px 0px 0px #000',
          }}>
            Update
          </button>
          <button onClick={() => handleDeleteDeal(editDeal.id)} style={{
            padding: '0.75rem', background: '#FF3B30', color: '#fff',
            border: '3px solid #000', borderRadius: '8px', cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '3px 3px 0px 0px #000',
          }}>
            <Trash2 size={18} />
          </button>
        </div>
      </div>
    </div>
  </div>
);
